"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.useGetMedia = exports.fetchMedia = void 0;
var _fetching = require("@ori/fetching");
var _presentationHttp = require("@ori/presentation-http");
var _models = require("../models");
var _utils = require("../utils");
var _externalUrl = require("./externalUrl");
var _utils2 = require("./utils");
/* istanbul ignore file @preserve --api */

const fetchMedia = async ({
  apiKey,
  categoryId,
  customerId,
  streamId,
  type
}) => {
  const {
    apiDomain,
    apiVersion,
    isRightsGiven,
    isIncludeTaggedGalleries,
    wrapResponses
  } = _externalUrl.baseConfig;
  const UrlPathAndQuery = `/media/recent?rights_given=${Number(isRightsGiven)}&version=${apiVersion}&include_tagged_galleries=${Number(isIncludeTaggedGalleries)}&auth_token=${apiKey}&wrap_responses=${wrapResponses}`;
  const typeToUrl = {
    FrontPage: customerId ? `${apiDomain}customers/${customerId}${UrlPathAndQuery}` : '',
    Gallery: customerId ? `${apiDomain}customers/${customerId}${UrlPathAndQuery}&count=12` : '',
    ProductDetails: streamId ? `${apiDomain}streams/${streamId}${UrlPathAndQuery}` : '',
    Category: categoryId ? `${apiDomain}categories/${categoryId}${UrlPathAndQuery}` : ''
  };
  const mediaUrl = typeToUrl[type];
  return (0, _externalUrl.getExternalUrl)(mediaUrl, {
    responseType: 'json'
  });
};
exports.fetchMedia = fetchMedia;
const getMedia = async ({
  apiKey,
  type,
  categoryId,
  customerId,
  streamId
}) => {
  const response = await fetchMedia({
    apiKey,
    type,
    categoryId,
    customerId,
    streamId
  });
  return (0, _presentationHttp.validateResponse)(response, {
    schema: _models.olapicResponseMediaSchema,
    onError: () => ({
      loadMoreUrl: '',
      mediaItems: []
    }),
    onSuccess: ({
      data
    }) => {
      const result = data.data;
      const items = result._embedded.media.map(_utils.createMediaItem);
      return {
        loadMoreUrl: result._links.next?.href ?? '',
        mediaItems: items
      };
    }
  });
};
const useGetMedia = ({
  apiKey,
  type,
  categoryId,
  customerId,
  streamId
}) => {
  const shouldFetch = (0, _utils2.shouldFetchMedia)({
    type,
    categoryId,
    customerId,
    streamId
  });
  const {
    data,
    error
  } = (0, _fetching.useSWR)(shouldFetch ? [apiKey, type, categoryId, customerId, streamId] : null, async () => getMedia({
    apiKey,
    type,
    categoryId,
    customerId,
    streamId
  }), {
    revalidateIfStale: false,
    revalidateOnFocus: false,
    revalidateOnReconnect: false
  });
  return {
    data,
    isLoading: data === undefined && error === undefined,
    isError: Boolean(error)
  };
};
exports.useGetMedia = useGetMedia;
